import React, { FunctionComponent, ReactNode } from 'react'
import styles from './ObjectName.module.sass'
import { WorkObject } from '../../../responses/objects'
import Ellipsis from '../Ellipsis/Ellipsis'
import clsx from 'clsx'

interface MyObject {
    name?: string,
    work_object_type: {
        work_object: WorkObject,
    },
}

interface Props<T extends MyObject = MyObject> {
    className?: string,
    object?: T,
    onClick?: () => void,
    children?: ReactNode, // overwrite object name
}

const ObjectName: FunctionComponent<Props> = props => <div className={clsx(props.className, styles.name)} onClick={props.onClick}>
    <Ellipsis className={styles.project}>{props.object?.work_object_type.work_object.name}</Ellipsis>
    &nbsp;
    {
        props.children ?
            <div className={styles.workObject}>{props.children}</div>:
            props.object?.name && <div className={styles.workObject}>[{props.object.name}]</div>
    }
</div>

export default ObjectName